import React from "react";
import { LayoutDashboard, Infinity as InfinityIcon, Headset, TrendingUp, Zap } from "lucide-react";
import { resellerBenefits } from "../../data/reseller";

const ICONS = { panel: LayoutDashboard, infinite: InfinityIcon, support: Headset, profit: TrendingUp, speed: Zap };

export const ResellerBenefits = () => (
  <section className="max-w-[1300px] mx-auto px-5 md:px-6 py-16" data-testid="reseller-benefits">
    <h2 className="text-3xl md:text-4xl font-extrabold tracking-tight">
      Por que revender <span className="brand-gradient-text">MasterX</span>?
    </h2>
    <p className="mt-3 text-silver/75 max-w-2xl">Tudo o que você precisa para começar e crescer, sem complicação.</p>
    <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-5 gap-4">
      {resellerBenefits.map((b, i) => {
        const Icon = ICONS[b.icon];
        return (
          <div
            key={b.title}
            data-testid={`reseller-benefit-${i + 1}`}
            className="group rounded-2xl border border-white/10 bg-surface/60 p-6 hover:border-brand-2/50 hover:-translate-y-1 transition"
          >
            <span className="w-12 h-12 rounded-xl bg-brand-gradient flex items-center justify-center shadow-lg shadow-brand/20">
              <Icon className="w-6 h-6 text-white" />
            </span>
            <h3 className="mt-5 text-lg font-bold leading-snug">{b.title}</h3>
            <p className="mt-2 text-sm text-silver/70 leading-relaxed">{b.desc}</p>
          </div>
        );
      })}
    </div>
  </section>
);
